import React from 'react';
import {Pie} from '@ant-design/plots';
import {Card, Spin, Button, Tooltip} from 'antd';
import {FileExcelFilled} from '@ant-design/icons';
import * as XLSX from 'xlsx';

const OnlineDonut = ({user, loading, data}) => {

    const handleDownload = () => {
        const title = 'Haberleşme_Durumu_Raporu';
        const workbook = XLSX.utils.book_new();

        const header = [
            ['Rapor Tipi:', 'Haberleşme Durumu'],
            ['Rapor Oluşturma Tarihi:', new Date().toLocaleString()],
            ['Raporu Oluşturan:', user?.name || 'Bilinmiyor'],
            [`Online Araçlar: ${data[0]?.value || 0}`, `Offline Araçlar: ${data[1]?.value || 0}`],
            [''],
            ['Online Araçlar', '', '', 'Offline Araçlar'],
            ['Plaka', 'Kapı Numarası', '', 'Plaka', 'Kapı Numarası']
        ];

        const maxRows = Math.max(
            data[0]?.vehicles.length || 0,
            data[1]?.vehicles.length || 0
        );

        const body = Array.from({length: maxRows}).map((_, index) => [
            data[0]?.vehicles[index]?.plateNumber || '',
            data[0]?.vehicles[index]?.operationNumber || '',
            '',
            data[1]?.vehicles[index]?.plateNumber || '',
            data[1]?.vehicles[index]?.operationNumber || ''
        ]);

        const worksheetData = [...header, ...body];

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const maxWidths = worksheetData[0].map((_, colIndex) =>
            Math.max(...worksheetData.map(row => (row[colIndex]?.toString().length || 0)))
        );

        worksheet['!cols'] = maxWidths.map(width => ({width}));
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Haberleşme Durumu Raporu');
        XLSX.writeFile(workbook, `${title}.xlsx`);
    };

    const config = {
        appendPadding: 10,
        data: data,
        angleField: 'value',
        colorField: 'type',
        color: ['green', 'gray'],
        radius: 0.9,
        animation: false,
        label: {
            type: 'inner',
            offset: '-30%',
            content: ({percent}) => `${(percent * 100).toFixed(0)}%`,
            style: {fontSize: 14, textAlign: 'center'},
        },
        interactions: [{type: 'element-active'}],
    };

    return (
        <Card
            type="inner"
            size="small"
            title="Haberleşme Durumu"
            extra={
                <Tooltip title="Rapor olarak indir">
                    <Button
                        type="text"
                        icon={<FileExcelFilled/>}
                        onClick={handleDownload}
                    />
                </Tooltip>
            }
        >
            <div style={{position: 'relative', height: 355}}>
                {loading ? (
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                        }}
                    >
                        <Spin/>
                    </div>
                ) : (
                    <Pie {...config} style={{height: 355}}/>
                )}
            </div>
        </Card>
    );
};

export default OnlineDonut;
